export const tablePaperStyles = {
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
};
